import { createSlice } from '@reduxjs/toolkit'

const multiStepSlice = createSlice({
    name: 'multiStep',
    initialState: {
        values: {},
        step: 0
    },
    reducers: {
        update: (state, action) => {
            for (let data in action.payload) {
                state.values[data] = action.payload[data]
            }
        },

        nextStep: (state) => {
            state.step += 1
        },
        customStep: (state, action) => {
            state.step = action.payload
        },

        previousStep: (state) => {
            state.step -= 1
        },
        emptyValues: (state) => {
            state.values = {}
            state.step = 0
        },
        resetAndUpdate: (state, action) => {
            state.values = {}; // Reset values
            Object.assign(state.values, action.payload); // Update with new values
        },

    },
});

export const { update, nextStep, previousStep, emptyValues, resetAndUpdate, customStep } = multiStepSlice.actions;
export default multiStepSlice.reducer